import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Download Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=960%3A23049&mode=dev)
 * */
const CheckmarkIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g><path d="M2 7.26333L3.63333 9.58133C3.69529 9.67388 3.77845 9.75029 3.8759 9.80421C3.97335 9.85812 4.08226 9.88799 4.19358 9.89131C4.3049 9.89464 4.4154 9.87133 4.5159 9.82333C4.61639 9.77532 4.70396 9.70401 4.77133 9.61533L10 3" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CheckmarkIcon;